<svg class="glyph" width="987" height="727" viewBox="0 0 987 727" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 734.905H341.262L734.905 0L1051.3 734.905H624.854L320.628 220.63L0 734.905Z" fill="#4782B6" />
</svg>

<div style="position: absolute; top: 15px; right: 50px">
  <topo-theme-switcher></topo-theme-switcher>
</div>

<div fxLayout="row" fxLayoutAlign="center space-around">
  <div class="box page-box">
    <div fxLayout="column" fxLayoutAlign="center space-around">
      <div fxLayout="row" fxLayoutAlign="center space-around">
        <div>
          <topo-logo></topo-logo>
        </div>
        <div>
          <div class="split-line"></div>
        </div>
        <div>
          <span class="text is-xlarge is-bolder mt-3">{{ 'LOGIN.SHARED-MAP' | translate }}</span>
        </div>
      </div>
      @if (!error) {
        <div style="position: relative !important; height: 100px" class="mt-4 mb-5">
          <ngx-spinner bdColor="rgba(0,0,0,0)" size="medium" color="#4D33CC" type="ball-clip-rotate"
            [fullScreen]="false" [zIndex]="998">
            <h5 style="position: absolute !important; top: 36px; right: -220px; width: 300px;" class="mx-4 my-4">
            {{ 'LOGIN.LOADING-SHARED-MAP' | translate }}</h5>
          </ngx-spinner>
        </div>
      }
      @if (error) {
        <div style="margin-top: 20px; text-align: center;">
          <h5>{{ 'LOGIN.SHARED-MAP-ERROR' | translate }}</h5>
        </div>
      }
    </div>
  </div>
</div>
